import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import bg1 from "assets/images/examples/content-5.jpg";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/content-5.jpg";

//other
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import PublicIcon from "@mui/icons-material/Public";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import Autocomplete from "@mui/material/Autocomplete";

// function ReviewItem({ label, value, highlight }) {
//   if (!value || (Array.isArray(value) && value.length === 0)) return null;

//   return (
//     <MKBox display="flex" justifyContent="space-between" mb={1}>
//       <MKTypography variant="body2" color="text.secondary">
//         {label}
//       </MKTypography>

//       <MKTypography
//         variant="body2"
//         fontWeight={highlight ? 600 : 500}
//         color={highlight ? "#700808" : "text.primary"}
//         textAlign="right"
//         sx={{ maxWidth: "60%" }}
//       >
//         {Array.isArray(value) ? value.join(", ") : value}
//       </MKTypography>
//     </MKBox>
//   );
// }

// function EmployerInfoStep({ formData, setFormData }) {
//   const languageOptions = ["Swahili", "English", "Kinyarwanda", "Luganda", "French"];

//   const handleChange = (field) => (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       employer: {
//         ...prev.employer,
//         [field]: e.target.value,
//       },
//     }));
//   };

//   const handleLanguages = (e, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       employer: {
//         ...prev.employer,
//         languages: value,
//       },
//     }));
//   };

//   return (
//     <>
//       <MKBox mb={4}>
//         {/* Section Title */}
//         <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//           <MKTypography variant="body2" mb={2} color="text.secondary">
//             Fill in your details below — from Contact to Location and Language Preferences
//           </MKTypography>
//           <MKTypography
//             component={Link}
//             to="/booking"
//             variant="body2"
//             mb={2}
//             fontWeight="medium"
//             sx={{
//               textDecoration: "underline",
//               textUnderlineOffset: "3px",
//               textDecorationColor: "#700808",
//               color: "#700808",
//               fontWeight: 500,
//               cursor: "pointer",
//               "&:hover": {
//                 opacity: 0.8,
//                 textDecorationColor: "#700808",
//               },
//             }}
//           >
//             Other services
//           </MKTypography>
//         </MKBox>
//         {/* Modern Separator */}
//         <MKBox
//           sx={{
//             height: "2px",
//             width: "100%",
//             background: "linear-gradient(90deg, #700808, rgba(112,8,8,0.2), transparent)",
//             borderRadius: "4px",
//             mb: 3,
//           }}
//         />
//         {/* Form */}
//         <Grid container spacing={3}>
//           {/* Full Name */}
//           <Grid item xs={12} md={6}>
//             <MKInput
//               value={formData.employer.fullName}
//               onChange={handleChange("fullName")}
//               variant="outlined"
//               label="Full Name"
//               placeholder="Enter your full name"
//               size="large"
//               fullWidth
//               startAdornment={<PersonIcon sx={{ mr: 1, color: "gray" }} />}
//             />
//           </Grid>

//           {/* Phone */}
//           <Grid item xs={12} md={6}>
//             <MKInput
//               value={formData.employer.phone}
//               onChange={handleChange("phone")}
//               variant="outlined"
//               label="Phone Number (WhatsApp preferred)"
//               placeholder="+250..."
//               size="large"
//               fullWidth
//               startAdornment={<PhoneIcon sx={{ mr: 1, color: "gray" }} />}
//             />
//           </Grid>

//           {/* Email */}
//           <Grid item xs={12} md={6}>
//             <MKInput
//               value={formData.employer.email}
//               onChange={handleChange("email")}
//               variant="outlined"
//               label="Email (Optional)"
//               placeholder="Enter email"
//               size="large"
//               fullWidth
//               startAdornment={<EmailIcon sx={{ mr: 1, color: "gray" }} />}
//             />
//           </Grid>

//           {/* Nationality */}
//           <Grid item xs={12} md={6}>
//             <MKInput
//               value={formData.employer.nationality}
//               onChange={handleChange("nationality")}
//               variant="outlined"
//               label="Nationality"
//               placeholder="Enter nationality"
//               size="large"
//               fullWidth
//               startAdornment={<PublicIcon sx={{ mr: 1, color: "gray" }} />}
//             />
//           </Grid>

//           {/* Location */}
//           <Grid item xs={12} md={6}>
//             <MKInput
//               value={formData.employer.location}
//               onChange={handleChange("location")}
//               variant="outlined"
//               label="Current Location (Country / City / Area)"
//               placeholder="e.g. Rwanda, Kigali, Kacyiru"
//               size="large"
//               fullWidth
//               startAdornment={<LocationOnIcon sx={{ mr: 1, color: "gray" }} />}
//             />
//           </Grid>

//           {/* Preferred Language */}
//           <Grid item xs={12} md={6}>
//             <Autocomplete
//               multiple
//               options={languageOptions}
//               value={formData.employer.languages}
//               onChange={handleLanguages}
//               renderInput={(params) => (
//                 <MKInput
//                   {...params}
//                   variant="outlined"
//                   placeholder="Preferred Language(s) - Select"
//                 />
//               )}
//             />
//           </Grid>
//         </Grid>
//       </MKBox>
//     </>
//   );
// }

// function HouseholdStep({ formData, setFormData }) {
//   const homeTypes = ["Apartment", "House", "Gated Compound", "Other"];
//   const maxChildren = 5; // 1–5 age options

//   // Handle home type selection
//   const handleHomeTypeChange = (type) => (e) => {
//     const value = e.target.checked;
//     setFormData((prev) => ({
//       ...prev,
//       household: {
//         ...prev.household,
//         homeType: value ? type : "",
//       },
//     }));
//   };

//   // Handle number of children checkboxes
//   const handleChildrenChange = (age) => (e) => {
//     const checked = e.target.checked;
//     setFormData((prev) => {
//       const updatedChildren = checked
//         ? [...prev.household.children, age]
//         : prev.household.children.filter((a) => a !== age);

//       return {
//         ...prev,
//         household: {
//           ...prev.household,
//           children: updatedChildren,
//         },
//       };
//     });
//   };

//   // Handle additional notes
//   const handleNotesChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       household: {
//         ...prev.household,
//         notes: e.target.value,
//       },
//     }));
//   };

//   return (
//     <MKBox mb={4}>
//       {/* Section Title */}
//       <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <MKTypography variant="body2" color="text.secondary">
//           Fill in your household details — home type, number of children, and any additional notes.
//         </MKTypography>
//         <MKTypography
//           component={Link}
//           to="/booking"
//           variant="body2"
//           mb={2}
//           fontWeight="medium"
//           sx={{
//             textDecoration: "underline",
//             textUnderlineOffset: "3px",
//             textDecorationColor: "#700808",
//             color: "#700808",
//             cursor: "pointer",
//             "&:hover": { opacity: 0.8 },
//           }}
//         >
//           Other services
//         </MKTypography>
//       </MKBox>
//       {/* Modern Separator */}
//       <MKBox
//         sx={{
//           height: "2px",
//           width: "100%",
//           background: "linear-gradient(90deg, #700808, rgba(112,8,8,0.2), transparent)",
//           borderRadius: "4px",
//           mb: 3,
//         }}
//       />
//       {/* Form */}
//       <Grid container spacing={3}>
//         {/* Home Type */}
//         <Grid item xs={12}>
//           <MKTypography variant="button" mb={1}>
//             Type of Home
//           </MKTypography>
//           <Grid container spacing={1}>
//             {homeTypes.map((type) => (
//               <Grid item key={type}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={formData.household.homeType === type}
//                       onChange={handleHomeTypeChange(type)}
//                       color="primary"
//                     />
//                   }
//                   label={type}
//                 />
//               </Grid>
//             ))}
//             {/* Optional text input if "Other" */}
//             {formData.household.homeType === "Other" && (
//               <Grid item xs={12} md={4}>
//                 <MKInput
//                   value={formData.household.otherHomeType || ""}
//                   onChange={(e) =>
//                     setFormData((prev) => ({
//                       ...prev,
//                       household: { ...prev.household, otherHomeType: e.target.value },
//                     }))
//                   }
//                   placeholder="Specify other"
//                   fullWidth
//                   size="small"
//                 />
//               </Grid>
//             )}
//           </Grid>
//         </Grid>

//         {/* Number of Children */}
//         <Grid item xs={12}>
//           <MKTypography variant="button" mb={1}>
//             Number of Children (with ages)
//           </MKTypography>
//           <Grid container spacing={1}>
//             {[...Array(maxChildren)].map((_, i) => {
//               const age = i + 1;
//               return (
//                 <Grid item key={age}>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={formData.household.children.includes(age)}
//                         onChange={handleChildrenChange(age)}
//                         color="primary"
//                       />
//                     }
//                     label={`${age} age`}
//                   />
//                 </Grid>
//               );
//             })}
//             {/* Other children input */}
//             <Grid item xs={12} md={4}>
//               <MKInput
//                 value={formData.household.otherChildren || ""}
//                 onChange={(e) =>
//                   setFormData((prev) => ({
//                     ...prev,
//                     household: { ...prev.household, otherChildren: e.target.value },
//                   }))
//                 }
//                 placeholder="Other"
//                 fullWidth
//                 size="small"
//               />
//             </Grid>
//           </Grid>
//         </Grid>

//         {/* Additional Notes */}
//         <Grid item xs={12}>
//           <MKTypography variant="button" mb={1}>
//             Additional Notes
//           </MKTypography>
//           <MKInput
//             value={formData.household.notes}
//             onChange={handleNotesChange}
//             multiline
//             rows={4}
//             placeholder="Any additional information..."
//             fullWidth
//           />
//         </Grid>
//       </Grid>
//     </MKBox>
//   );
// }

// function CareNeedsStep({ formData, setFormData }) {
//   // --- Handlers ---
//   const handleCheckbox = (field) => (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       care: {
//         ...prev.care,
//         [field]: e.target.checked,
//       },
//     }));
//   };

//   const handleText = (field) => (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       care: {
//         ...prev.care,
//         [field]: e.target.value,
//       },
//     }));
//   };

//   const handleArray = (field, value) => (e) => {
//     const checked = e.target.checked;
//     setFormData((prev) => {
//       const updated = checked
//         ? [...(prev.care[field] || []), value]
//         : prev.care[field].filter((v) => v !== value);

//       return {
//         ...prev,
//         care: {
//           ...prev.care,
//           [field]: updated,
//         },
//       };
//     });
//   };

//   // --- Options ---
//   const petsOptions = ["Dog", "Cat", "Birds"];

//   return (
//     <MKBox mb={4}>
//       {/* Section Title */}
//       <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <MKTypography variant="body2" mb={2} color="text.secondary">
//           Provide information about children, elderly, and pets that require special attention.
//         </MKTypography>
//         <MKTypography
//           component={Link}
//           to="/booking"
//           variant="body2"
//           mb={2}
//           fontWeight="medium"
//           sx={{
//             textDecoration: "underline",
//             textUnderlineOffset: "3px",
//             textDecorationColor: "#700808",
//             color: "#700808",
//             fontWeight: 500,
//             cursor: "pointer",
//             "&:hover": {
//               opacity: 0.8,
//               textDecorationColor: "#700808",
//             },
//           }}
//         >
//           Other services
//         </MKTypography>
//       </MKBox>
//       {/* Modern Separator */}
//       <MKBox
//         sx={{
//           height: "2px",
//           width: "100%",
//           background: "linear-gradient(90deg, #700808, rgba(112,8,8,0.2), transparent)",
//           borderRadius: "4px",
//           mb: 3,
//         }}
//       />
//       <Grid container spacing={3}>
//         {/* --- Children --- */}
//         <Grid item xs={12}>
//           <MKTypography variant="button">
//             Children with any condition or mobility status
//           </MKTypography>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.care.childrenSpecial || false}
//                 onChange={handleCheckbox("childrenSpecial")}
//               />
//             }
//             label="Yes"
//           />
//         </Grid>

//         {formData.care.childrenSpecial && (
//           <>
//             <Grid item xs={12}>
//               <MKInput
//                 value={formData.care.childrenDetails || ""}
//                 onChange={handleText("childrenDetails")}
//                 placeholder="Age(s) and mobility status"
//                 fullWidth
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <MKTypography variant="button">
//                 Special attention needed (daily medication)
//               </MKTypography>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.care.childrenMedication || false}
//                     onChange={handleCheckbox("childrenMedication")}
//                   />
//                 }
//                 label="Yes"
//               />
//               {formData.care.childrenMedication && (
//                 <MKInput
//                   value={formData.care.childrenMedicationDesc || ""}
//                   onChange={handleText("childrenMedicationDesc")}
//                   placeholder="Describe"
//                   fullWidth
//                 />
//               )}
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.care.childrenNurse || false}
//                     onChange={handleCheckbox("childrenNurse")}
//                   />
//                 }
//                 label="Professional Nurse needed"
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.care.childrenDoctor || false}
//                     onChange={handleCheckbox("childrenDoctor")}
//                   />
//                 }
//                 label="Follow up doctor appointments"
//               />
//             </Grid>
//           </>
//         )}

//         {/* --- Elderly --- */}
//         <Grid item xs={12}>
//           <MKTypography variant="button">Any Elderly Persons at Home?</MKTypography>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.care.elderlyPresent || false}
//                 onChange={handleCheckbox("elderlyPresent")}
//               />
//             }
//             label="Yes"
//           />
//         </Grid>

//         {formData.care.elderlyPresent && (
//           <>
//             <Grid item xs={12}>
//               <MKInput
//                 value={formData.care.elderlyDetails || ""}
//                 onChange={handleText("elderlyDetails")}
//                 placeholder="Age(s) and mobility status"
//                 fullWidth
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <MKTypography variant="button">
//                 Special attention needed (daily medication)
//               </MKTypography>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.care.elderlyMedication || false}
//                     onChange={handleCheckbox("elderlyMedication")}
//                   />
//                 }
//                 label="Yes"
//               />
//               {formData.care.elderlyMedication && (
//                 <MKInput
//                   value={formData.care.elderlyMedicationDesc || ""}
//                   onChange={handleText("elderlyMedicationDesc")}
//                   placeholder="Describe"
//                   fullWidth
//                 />
//               )}
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.care.elderlyNurse || false}
//                     onChange={handleCheckbox("elderlyNurse")}
//                   />
//                 }
//                 label="Professional Nurse needed"
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.care.elderlyDoctor || false}
//                     onChange={handleCheckbox("elderlyDoctor")}
//                   />
//                 }
//                 label="Follow up doctor appointments"
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <MKInput
//                 value={formData.care.elderlyNotes || ""}
//                 onChange={handleText("elderlyNotes")}
//                 placeholder="Additional notes"
//                 fullWidth
//                 multiline
//                 rows={3}
//               />
//             </Grid>
//           </>
//         )}

//         {/* --- Pets --- */}
//         <Grid item xs={12}>
//           <MKTypography variant="button">Any Pets?</MKTypography>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.care.petsPresent || false}
//                 onChange={handleCheckbox("petsPresent")}
//               />
//             }
//             label="Yes"
//           />
//         </Grid>

//         {formData.care.petsPresent && (
//           <>
//             <Grid item xs={12}>
//               <MKTypography variant="button">Select pet types</MKTypography>
//               <Grid container spacing={1}>
//                 {petsOptions.map((pet) => (
//                   <Grid item key={pet}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={formData.care.petsTypes?.includes(pet) || false}
//                           onChange={handleArray("petsTypes", pet)}
//                         />
//                       }
//                       label={pet}
//                     />
//                   </Grid>
//                 ))}

//                 {/* Other pets input */}
//                 <Grid item xs={12} md={4}>
//                   <MKInput
//                     value={formData.care.petsOther || ""}
//                     onChange={handleText("petsOther")}
//                     placeholder="Other"
//                     fullWidth
//                     size="small"
//                   />
//                 </Grid>
//               </Grid>
//             </Grid>
//           </>
//         )}
//       </Grid>
//     </MKBox>
//   );
// }

// function NannyChildcareTasksStep({ formData, setFormData }) {
//   const tasks = [
//     "Babysitting / teaching baby, young kids",
//     "Preparing meals for children",
//     "School pick-up/drop-off",
//     "Helping with homework",
//     "Bathing and dressing kids",
//     "Putting children to bed",
//   ];

//   const handleTask = (task, value) => () => {
//     setFormData((prev) => ({
//       ...prev,
//       tasks: {
//         ...prev.tasks,
//         childcare: {
//           ...prev.tasks.childcare,
//           [task]: value === "yes",
//         },
//       },
//     }));
//   };

//   return (
//     <Grid container spacing={2}>
//       {tasks.map((task) => (
//         <Grid item xs={12} key={task}>
//           <MKBox display="flex" alignItems="center">
//             <MKTypography sx={{ flex: 1 }}>{task}</MKTypography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.tasks.childcare?.[task] === true}
//                   onChange={handleTask(task, "yes")}
//                 />
//               }
//               label="Yes"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.tasks.childcare?.[task] === false}
//                   onChange={handleTask(task, "no")}
//                 />
//               }
//               label="No"
//             />
//           </MKBox>
//         </Grid>
//       ))}
//     </Grid>
//   );
// }

// function BabyCleaningTasksStep({ formData, setFormData }) {
//   const tasks = [
//     "Sweeping and mopping baby areas",
//     "Dusting baby areas",
//     "Laundry baby clothes (hand)",
//     "Laundry baby clothes (machine)",
//     "Ironing baby clothes",
//     "Organizing baby wardrobe",
//   ];

//   const handleTask = (task, value) => () => {
//     setFormData((prev) => ({
//       ...prev,
//       tasks: {
//         ...prev.tasks,
//         babyCare: {
//           ...prev.tasks.babyCare,
//           [task]: value === "yes",
//         },
//       },
//     }));
//   };

//   return (
//     <Grid container spacing={2}>
//       {tasks.map((task) => (
//         <Grid item xs={12} key={task}>
//           <MKBox display="flex" alignItems="center">
//             <MKTypography sx={{ flex: 1 }}>{task}</MKTypography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.tasks.babyCare?.[task] === true}
//                   onChange={handleTask(task, "yes")}
//                 />
//               }
//               label="Yes"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.tasks.babyCare?.[task] === false}
//                   onChange={handleTask(task, "no")}
//                 />
//               }
//               label="No"
//             />
//           </MKBox>
//         </Grid>
//       ))}
//     </Grid>
//   );
// }

// function ScheduleLanguageStep({ formData, setFormData }) {
//   const handleSchedule = (field) => (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       schedule: {
//         ...prev.schedule,
//         [field]: e.target.value,
//       },
//     }));
//   };

//   const handleScheduleCheckbox = (field) => (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       schedule: {
//         ...prev.schedule,
//         [field]: e.target.checked,
//       },
//     }));
//   };

//   const handleLanguageLevel = (language) => (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       languageLevels: {
//         ...prev.languageLevels,
//         [language]: e.target.value,
//       },
//     }));
//   };

//   return (
//     <MKBox mb={4}>
//       {/* Header */}
//       <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <MKTypography variant="body2" color="text.secondary">
//           Provide nanny / housekeeper schedule and language preferences
//         </MKTypography>

//         <MKTypography
//           component={Link}
//           to="/booking"
//           variant="body2"
//           sx={{
//             textDecoration: "underline",
//             textUnderlineOffset: "3px",
//             color: "#700808",
//             fontWeight: 500,
//             cursor: "pointer",
//           }}
//         >
//           Other services
//         </MKTypography>
//       </MKBox>

//       {/* Separator */}
//       <MKBox
//         sx={{
//           height: "2px",
//           width: "100%",
//           background: "linear-gradient(90deg, #700808, rgba(112,8,8,0.25), transparent)",
//           borderRadius: "4px",
//           mb: 3,
//         }}
//       />

//       <Grid container spacing={3}>
//         {/* Live Type */}
//         <Grid item xs={12}>
//           <FormLabel>Live-In or Live-Out?</FormLabel>
//           <RadioGroup row value={formData.schedule.liveType} onChange={handleSchedule("liveType")}>
//             <FormControlLabel
//               value="Live-In"
//               control={<Radio />}
//               label="Live-In (1 day off required, meals provided)"
//             />
//             <FormControlLabel value="Live-Out" control={<Radio />} label="Live-Out" />
//           </RadioGroup>
//         </Grid>

//         {/* Working Hours */}
//         <Grid item xs={12} md={6}>
//           <MKInput
//             label="Start Time"
//             placeholder="e.g. 08:00 AM"
//             value={formData.schedule.startTime}
//             onChange={handleSchedule("startTime")}
//             fullWidth
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <MKInput
//             label="End Time"
//             placeholder="e.g. 05:00 PM"
//             value={formData.schedule.endTime}
//             onChange={handleSchedule("endTime")}
//             fullWidth
//           />
//         </Grid>

//         {/* Working Days */}
//         <Grid item xs={12}>
//           <FormLabel>Working Days</FormLabel>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.schedule.mondayFriday}
//                 onChange={handleScheduleCheckbox("mondayFriday")}
//               />
//             }
//             label="Monday – Friday"
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.schedule.mondaySaturday}
//                 onChange={handleScheduleCheckbox("mondaySaturday")}
//               />
//             }
//             label="Monday – Saturday"
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.schedule.fullWeek}
//                 onChange={handleScheduleCheckbox("fullWeek")}
//               />
//             }
//             label="Full Week"
//           />
//         </Grid>

//         {/* Day Off */}
//         {formData.schedule.liveType === "Live-In" && (
//           <Grid item xs={12}>
//             <MKInput
//               label="Preferred Day Off"
//               placeholder="e.g. Sunday"
//               value={formData.schedule.dayOff}
//               onChange={handleSchedule("dayOff")}
//               fullWidth
//             />
//           </Grid>
//         )}

//         {/* Weekend Work */}
//         <Grid item xs={12}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.schedule.weekendWork}
//                 onChange={handleScheduleCheckbox("weekendWork")}
//               />
//             }
//             label="Weekend work required?"
//           />
//         </Grid>

//         {/* Meals & Accommodation */}
//         <Grid item xs={12} md={6}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.schedule.provideMeals}
//                 onChange={handleScheduleCheckbox("provideMeals")}
//               />
//             }
//             label="Provide meals?"
//           />
//         </Grid>

//         {formData.schedule.liveType === "Live-In" && (
//           <Grid item xs={12} md={6}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.schedule.provideAccommodation}
//                   onChange={handleScheduleCheckbox("provideAccommodation")}
//                 />
//               }
//               label="Provide accommodation?"
//             />
//           </Grid>
//         )}

//         {/* Other Helpers */}
//         <Grid item xs={12}>
//           <MKInput
//             label="Other Helpers"
//             placeholder="Maid, nanny, guard, driver..."
//             value={formData.schedule.otherHelpers}
//             onChange={handleSchedule("otherHelpers")}
//             fullWidth
//             multiline
//             rows={2}
//           />
//         </Grid>

//         {/* Language */}
//         <Grid item xs={12}>
//           <MKTypography variant="h5" mb={1}>
//             Language Requirements
//           </MKTypography>

//           {["English", "Swahili", "Luganda", "French", "Kinyarwanda"].map((lang) => (
//             <RadioGroup
//               row
//               key={lang}
//               value={formData.languageLevels[lang]}
//               onChange={handleLanguageLevel(lang)}
//               sx={{ mb: 1 }}
//             >
//               <FormLabel sx={{ mr: 2 }}>{lang}:</FormLabel>
//               <FormControlLabel value="Fluent" control={<Radio />} label="Fluent" />
//               <FormControlLabel value="Medium" control={<Radio />} label="Medium" />
//               <FormControlLabel value="Basic" control={<Radio />} label="Basic" />
//             </RadioGroup>
//           ))}
//         </Grid>

//         {/* Notes */}
//         <Grid item xs={12}>
//           <MKInput
//             label="Additional Notes"
//             placeholder="Any special expectations or instructions"
//             value={formData.schedule.notes}
//             onChange={handleSchedule("notes")}
//             fullWidth
//             multiline
//             rows={3}
//           />
//         </Grid>
//       </Grid>
//     </MKBox>
//   );
// }

// function ContractPeriodStep({ formData, setFormData }) {
//   const contractOptions = ["Full Year", "6 Months", "3 Months", "1 Month", "Few Weeks"];

//   const handleContractChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       contractPeriod: e.target.value,
//     }));
//   };

//   return (
//     <MKBox mb={4}>
//       {/* Section Title */}
//       <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <MKTypography variant="body2" mb={2} color="text.secondary">
//           Please select the contract duration you want for the housekeeper full package.
//         </MKTypography>
//         <MKTypography
//           component={Link}
//           to="/booking"
//           variant="body2"
//           mb={2}
//           fontWeight="medium"
//           sx={{
//             textDecoration: "underline",
//             textUnderlineOffset: "3px",
//             textDecorationColor: "#700808",
//             color: "#700808",
//             fontWeight: 500,
//             cursor: "pointer",
//             "&:hover": {
//               opacity: 0.8,
//               textDecorationColor: "#700808",
//             },
//           }}
//         >
//           Other services
//         </MKTypography>
//       </MKBox>
//       {/* Modern Separator */}
//       <MKBox
//         sx={{
//           height: "2px",
//           width: "100%",
//           background: "linear-gradient(90deg, #700808, rgba(112,8,8,0.2), transparent)",
//           borderRadius: "4px",
//           mb: 3,
//         }}
//       />
//       <FormLabel component="legend">Contract Duration</FormLabel>
//       <RadioGroup value={formData.contractPeriod || ""} onChange={handleContractChange}>
//         {contractOptions.map((option) => (
//           <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
//         ))}
//       </RadioGroup>
//     </MKBox>
//   );
// }

// function ReviewSubmitStep({ formData, setFormData }) {
//   const reviewCardStyle = {
//     p: 3,
//     borderRadius: "1.5rem",
//     backgroundColor: "#fff",
//     border: "1px solid rgba(0,0,0,0.08)",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.03)",
//   };

//   return (
//     <MKBox mb={4}>
//       {/* Header */}
//       <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <MKTypography variant="body2" color="text.secondary">
//           Review your information before submitting your request.
//         </MKTypography>

//         <MKTypography
//           component={Link}
//           to="/booking"
//           variant="body2"
//           sx={{
//             textDecoration: "underline",
//             textUnderlineOffset: "3px",
//             color: "#700808",
//             cursor: "pointer",
//           }}
//         >
//           Other services
//         </MKTypography>
//       </MKBox>

//       {/* Separator */}
//       <MKBox
//         sx={{
//           height: 2,
//           width: "100%",
//           background: "linear-gradient(90deg, #700808, rgba(112,8,8,0.25), transparent)",
//           borderRadius: 2,
//           mb: 3,
//         }}
//       />

//       {/* REVIEW SECTIONS */}
//       <Grid container spacing={3}>
//         {/* Employer Info */}
//         <Grid item xs={12} md={6}>
//           <MKBox sx={reviewCardStyle}>
//             <MKTypography fontWeight={600} mb={2}>
//               Employer Information
//             </MKTypography>

//             <ReviewItem label="Full Name" value={formData.employer?.fullName} />
//             <ReviewItem label="Phone" value={formData.employer?.phone} />
//             <ReviewItem label="Email" value={formData.employer?.email} />
//             <ReviewItem label="Location" value={formData.employer?.location} />
//             <ReviewItem label="Languages" value={formData.employer?.languages} />
//           </MKBox>
//         </Grid>

//         {/* Household Info */}
//         <Grid item xs={12} md={6}>
//           <MKBox sx={reviewCardStyle}>
//             <MKTypography fontWeight={600} mb={2}>
//               Household Details
//             </MKTypography>

//             <ReviewItem label="Home Type" value={formData.household?.homeType} />
//             <ReviewItem
//               label="Children Ages"
//               value={formData.household?.children?.map((c) => `${c} yrs`)}
//             />
//             <ReviewItem label="Other Children" value={formData.household?.otherChildren} />
//             <ReviewItem label="Notes" value={formData.household?.notes} />
//           </MKBox>
//         </Grid>

//         {/* Care Needs */}
//         <Grid item xs={12}>
//           <MKBox sx={reviewCardStyle}>
//             <MKTypography fontWeight={600} mb={2}>
//               Special Care Needs
//             </MKTypography>

//             <ReviewItem
//               label="Children Special Care"
//               value={formData.care?.childrenSpecial ? "Yes" : "No"}
//             />
//             <ReviewItem label="Children Details" value={formData.care?.childrenDetails} />

//             <ReviewItem
//               label="Elderly Present"
//               value={formData.care?.elderlyPresent ? "Yes" : "No"}
//             />
//             <ReviewItem label="Elderly Notes" value={formData.care?.elderlyNotes} />

//             <ReviewItem
//               label="Pets"
//               value={formData.care?.petsPresent ? formData.care?.petsTypes : "No"}
//             />
//           </MKBox>
//         </Grid>

//         {/* Schedule */}
//         <Grid item xs={12}>
//           <MKBox sx={reviewCardStyle}>
//             <MKTypography fontWeight={600} mb={2}>
//               Work Schedule
//             </MKTypography>

//             <ReviewItem label="Live Type" value={formData.schedule?.liveType} />

//             <ReviewItem
//               label="Working Hours"
//               value={
//                 formData.schedule?.startTime && formData.schedule?.endTime
//                   ? `${formData.schedule.startTime} - ${formData.schedule.endTime}`
//                   : ""
//               }
//             />

//             <ReviewItem
//               label="Meals Provided"
//               value={formData.schedule?.provideMeals ? "Yes" : "No"}
//             />

//             {formData.schedule?.liveType === "Live-In" && (
//               <ReviewItem
//                 label="Accommodation"
//                 value={formData.schedule?.provideAccommodation ? "Yes" : "No"}
//               />
//             )}

//             <ReviewItem label="Schedule Notes" value={formData.schedule?.notes} />

//             <ReviewItem label="Contract Duration" value={formData.contractPeriod} highlight />
//           </MKBox>
//         </Grid>
//       </Grid>

//       {/* Acknowledgment */}
//       <MKBox
//         mt={4}
//         p={2}
//         borderRadius="1rem"
//         sx={{
//           backgroundColor: "rgba(112,8,8,0.05)",
//           border: "1px solid rgba(112,8,8,0.15)",
//         }}
//       >
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={formData.acknowledgment || false}
//               onChange={(e) =>
//                 setFormData((prev) => ({
//                   ...prev,
//                   acknowledgment: e.target.checked,
//                 }))
//               }
//             />
//           }
//           label="I confirm that the information provided above is correct and complete."
//         />
//       </MKBox>
//     </MKBox>
//   );
// }

function Driver() {
  // const [activeStep, setActiveStep] = useState(0);
  // const [_status, setStatus] = useState("idle");
  // const [_isLoading, setIsLoading] = useState(false);
  // const [_isBooked, setIsBooked] = useState(false);
  // const [_alertMsg, setAlertMsg] = useState("");
  // const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  // const steps = [
  //   "Employer Info",
  //   "Household",
  //   "Care Needs",
  //   "Childcare Tasks",
  //   "Baby Cleaning Tasks",
  //   "Schedule & Language",
  //   "Contract Duration",
  //   "Review",
  // ];

  // const totalSteps = steps.length;
  // const progress = ((activeStep + 1) / totalSteps) * 100;

  // const handleNext = () => setActiveStep((s) => s + 1);
  // const handleBack = () => setActiveStep((s) => s - 1);

  // const [formData, setFormData] = useState({
  //   employer: {
  //     fullName: "",
  //     phone: "",
  //     email: "",
  //     nationality: "",
  //     location: "",
  //     countryCitizen: "",
  //     languages: [],
  //   },

  //   household: {
  //     homeType: "",
  //     otherHomeType: "",
  //     children: [],
  //     otherChildren: "",
  //     notes: "",
  //   },

  //   care: {
  //     childrenSpecial: false,
  //     childrenDetails: "",
  //     childrenMedication: false,
  //     childrenMedicationDesc: "",
  //     childrenNurse: false,
  //     childrenDoctor: false,

  //     elderlyPresent: false,
  //     elderlyDetails: "",
  //     elderlyMedication: false,
  //     elderlyMedicationDesc: "",
  //     elderlyNurse: false,
  //     elderlyDoctor: false,
  //     elderlyNotes: "",

  //     petsPresent: false,
  //     petsTypes: [],
  //     petsOther: "",
  //   },

  //   tasks: {
  //     childcare: {},
  //     babyCare: {},
  //     cleaning: {},
  //   },

  //   schedule: {
  //     liveType: "",
  //     startTime: "",
  //     endTime: "",
  //     workDays: "",
  //     dayOff: "",
  //     weekendWork: false,
  //     provideMeals: false,
  //     provideAccommodation: false,
  //     otherHelpers: "",
  //     notes: "",
  //   },

  //   languageLevels: {},
  //   acknowledgment: false,
  // });

  //normalize data before sending it
  // const normalizeTasks = (tasksObj) =>
  //   Object.entries(tasksObj).map(([task, value]) => ({
  //     task,
  //     value,
  //   }));

  // const buildPayload = (data) => ({
  //   ...data,

  //   tasks: {
  //     childcare: normalizeTasks(data.tasks.childcare),
  //     cooking: normalizeTasks(data.tasks.cooking),
  //     cleaning: normalizeTasks(data.tasks.cleaning),
  //     petsElderly: normalizeTasks(data.tasks.petsElderly),
  //   },

  //   submittedAt: new Date().toISOString(),
  // });

  // const handleSubmit = async () => {
  //   setStatus("loading");
  //   setIsLoading(true);

  //   try {
  //     const payload = buildPayload(formData);

  //     const res = await axios.post(`${SERVER_URL}/book/nanny/`, payload, {
  //       headers: { "Content-Type": "application/json" },
  //     });

  //     if (res.status === 200 && res.data === "Booked") {
  //       setAlertMsg("Email Sent! We'll Get Back to You Very Soon");
  //       setIsBooked(true);
  //       setStatus("success");
  //     } else {
  //       setStatus("error");
  //       alert("Booking failed. Please try again.");
  //     }
  //   } catch (err) {
  //     console.error("Submit error:", err);
  //     setStatus("error");
  //     alert("An error occurred while submitting your request.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const renderStepContent = (step) => {
  //   switch (step) {
  //     case 0:
  //       return <EmployerInfoStep formData={formData} setFormData={setFormData} />;

  //     case 1:
  //       return <HouseholdStep formData={formData} setFormData={setFormData} />;

  //     case 2:
  //       return <CareNeedsStep formData={formData} setFormData={setFormData} />;

  //     case 3:
  //       return <NannyChildcareTasksStep formData={formData} setFormData={setFormData} />;

  //     case 4:
  //       return <BabyCleaningTasksStep formData={formData} setFormData={setFormData} />;

  //     case 5:
  //       return <ScheduleLanguageStep formData={formData} setFormData={setFormData} />;

  //     case 6:
  //       return <ContractPeriodStep formData={formData} setFormData={setFormData} />;
  //     case 7:
  //       return <ReviewSubmitStep formData={formData} setFormData={setFormData} />;

  //     default:
  //       return null;
  //   }
  // };

  return (
    <>
      <>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/booking",
            label: "BOOK NOW",
            color: "info",
          }}
          transparent
          light
        />
        <MKBox
          minHeight="50vh"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
            py: 10,
          }}
        >
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={8}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={{ mx: "auto", textAlign: "center" }}
            >
              <MKTypography
                variant="h2"
                color="white"
                mb={2}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Discover Comfort and Convenience
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>

        {/* Wrapper for all cards */}
        <MKBox
          display="flex"
          flexDirection="column"
          alignItems="stretch" // <-- important
          gap={6}
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: 900, md: 1100, lg: 1200 }, // responsive width
            px: { xs: 2, sm: 3, md: 0 }, // side padding on small screens
            mx: "auto",
            mt: -8,
          }}
        >
          {/* Stepper Card */}
          {/* <Card
            sx={{
              width: "100%",
              p: { xs: 3, md: 5 },
              borderRadius: "2rem",
              background: "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,255,255,0.85))",
              backdropFilter: "blur(18px) saturate(160%)",
              boxShadow: "0 24px 48px rgba(0,0,0,0.1)",
              border: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            
            <MKBox display={{ xs: "block", md: "none" }}>
              <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <MKTypography fontWeight={600} sx={{ color: "#700808" }}>
                  Step {activeStep + 1}
                </MKTypography>
                <MKTypography variant="body2" color="text.secondary">
                  {totalSteps} steps
                </MKTypography>
              </MKBox>

              <MKBox
                sx={{
                  width: "100%",
                  height: 6,
                  borderRadius: 999,
                  backgroundColor: "rgba(112,8,8,0.12)",
                  overflow: "hidden",
                  mb: 1.5,
                }}
              >
                <MKBox
                  sx={{
                    width: `${progress}%`,
                    height: "100%",
                    background: "linear-gradient(90deg, #700808, #9e0b0b)",
                    transition: "width 0.5s cubic-bezier(.4,0,.2,1)",
                  }}
                />
              </MKBox>

              <MKTypography fontWeight={500}>{steps[activeStep]}</MKTypography>
            </MKBox>

            
            <MKBox display={{ xs: "none", md: "block" }} mb={4}>
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel
                      sx={{
                        "& .MuiStepIcon-root": {
                          color: "rgba(112,8,8,0.2)",
                          fontSize: "1.2rem",
                          transition: "all 0.3s ease",
                        },
                        "& .MuiStepIcon-root.Mui-active": {
                          color: "#700808",
                          fontSize: "1.4rem",
                        },
                        "& .MuiStepIcon-root.Mui-completed": {
                          color: "#700808",
                        },
                        "& .MuiStepLabel-label": {
                          fontSize: "0.85rem",
                          color: "rgba(0,0,0,0.5)",
                          mt: 1,
                        },
                        "& .MuiStepLabel-label.Mui-active": {
                          color: "#700808",
                          fontWeight: 600,
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </MKBox>

            
            <MKBox mt={{ xs: 3, md: 2 }}>{renderStepContent(activeStep)}</MKBox>

            
            <MKBox
              display="flex"
              justifyContent="space-between"
              mt={4}
              gap={2}
              flexDirection={{ xs: "column", sm: "row" }}
            >
            
              <MKButton
                fullWidth
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{
                  borderRadius: "1rem",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#700808",
                  backgroundColor: "rgba(112,8,8,0.06)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "rgba(112,8,8,0.12)",
                  },
                  "&:disabled": {
                    backgroundColor: "rgba(0,0,0,0.05)",
                    color: "rgba(112,8,8,0.3)",
                  },
                }}
              >
                Back
              </MKButton>

              
              <MKButton
                fullWidth
                onClick={activeStep === steps.length - 1 ? handleSubmit : handleNext}
                sx={{
                  borderRadius: "1rem",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  textTransform: "none",
                  background: "linear-gradient(90deg, #700808, #9e0b0b)",
                  color: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 10px 20px rgba(112,8,8,0.35)",
                    transform: "translateY(-1px)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                {activeStep === steps.length - 1 ? "Submit Request" : "Next"}
              </MKButton>
            </MKBox>
          </Card> */}
          <Card
            sx={{
              width: "100%",
              p: { xs: 6, md: 8 },
              borderRadius: "2rem",
              background: "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.9))",
              backdropFilter: "blur(14px) saturate(160%)",
              boxShadow: "0 30px 60px rgba(0,0,0,0.08)",
              border: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            <MKBox display="flex" flexDirection="column" alignItems="center" gap={6}>
              {/* Header */}
              <MKBox textAlign="center">
                <MKTypography variant="h3" fontWeight={700} sx={{ letterSpacing: "-0.5px" }}>
                  Drivers Request Form
                </MKTypography>
                <MKTypography variant="h6" color="text.secondary" mt={1}>
                  Coming Soon 🚗
                </MKTypography>
                <MKTypography variant="body2" color="text.secondary" mt={1}>
                  We are working hard to bring you this service. Stay tuned!
                </MKTypography>
              </MKBox>

              {/* Illustration / Placeholder */}
              <MKBox
                component="img"
                src={bg1}
                alt="Coming Soon"
                sx={{ maxWidth: 300, width: "100%", mt: 2 }}
              />

              {/* Contact for Info */}
              <MKBox textAlign="center">
                <MKTypography variant="body1" mb={1}>
                  For inquiries, reach us at:
                </MKTypography>
                <MKTypography variant="body2" color="#700808" fontWeight={500} sx={{ mb: 0.5 }}>
                  📞 (+250) 795 305 418 | (+250) 796 716 708 | (+250) 796 505 768
                </MKTypography>
                <MKTypography variant="body2" color="#700808" fontWeight={500}>
                  ✉ info@helpereverywhere.com
                </MKTypography>
              </MKBox>

              {/* Socials */}
              <MKBox display="flex" justifyContent="center" gap={2} mt={3}>
                {[
                  { icon: <WhatsAppIcon />, link: "https://wa.me/250795305418", color: "#25D366" },
                  {
                    icon: <FacebookIcon />,
                    link: "https://facebook.com/helpereverywhere",
                    color: "#1877F2",
                  },
                  {
                    icon: <InstagramIcon />,
                    link: "https://instagram.com/helpereverywhere",
                    color: "#E4405F",
                  },
                  {
                    icon: <TwitterIcon />,
                    link: "https://twitter.com/helpereverywhere",
                    color: "#1DA1F2",
                  },
                ].map((social, idx) => (
                  <MKBox
                    key={idx}
                    component="a"
                    href={social.link}
                    target="_blank"
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "14px",
                      backgroundColor: "rgba(0,0,0,0.04)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: social.color,
                        transform: "translateY(-2px)",
                        "& svg": { color: "#fff" },
                      },
                    }}
                  >
                    {React.cloneElement(social.icon, {
                      sx: { fontSize: "1.6rem", color: social.color },
                    })}
                  </MKBox>
                ))}
              </MKBox>

              {/* Address */}
              <MKTypography variant="body2" color="text.secondary" fontWeight={500} mt={3}>
                KG 314 ST, Kigali, Rwanda
              </MKTypography>
            </MKBox>
          </Card>

          <Card
            sx={{
              width: "100%",
              p: { xs: 4, md: 6 },
              borderRadius: "2rem",
              background: "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.9))",
              backdropFilter: "blur(14px) saturate(160%)",
              boxShadow: "0 30px 60px rgba(0,0,0,0.08)",
              border: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            <MKBox display="flex" flexDirection="column" alignItems="center" gap={6}>
              {/* Header */}
              <MKBox textAlign="center">
                <MKTypography variant="h4" fontWeight={600} sx={{ letterSpacing: "-0.5px" }}>
                  Other Ways to Reach Us
                </MKTypography>
                <MKTypography variant="body2" color="text.secondary" mt={1}>
                  We’re always available through the channels below
                </MKTypography>
              </MKBox>

              {/* Contact Info */}
              <Grid container spacing={4} justifyContent="center">
                {[
                  {
                    title: "Phone",
                    icon: <PhoneIcon />,
                    items: ["(+250) 795 305 418", "(+250) 796 716 708", "(+250) 796 505 768"],
                  },
                  {
                    title: "Email",
                    icon: <EmailIcon />,
                    items: [
                      "info@helpereverywhere.com",
                      "helpereverywheremail@gmail.com",
                      "support@helpereverywhere.com",
                    ],
                  },
                ].map((block, idx) => (
                  <Grid item xs={12} md={4} key={idx}>
                    <MKBox
                      p={4}
                      borderRadius="1.75rem"
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 16px 30px rgba(0,0,0,0.06)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 24px 40px rgba(0,0,0,0.08)",
                        },
                      }}
                    >
                      {/* Title */}
                      <MKBox display="flex" alignItems="center" gap={1.5} mb={3}>
                        <MKBox
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "12px",
                            backgroundColor: "rgba(112,8,8,0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {React.cloneElement(block.icon, {
                            sx: { color: "#700808", fontSize: "1.4rem" },
                          })}
                        </MKBox>

                        <MKTypography variant="h6" fontWeight={600}>
                          {block.title}
                        </MKTypography>
                      </MKBox>

                      {/* Items */}
                      <MKBox display="flex" flexDirection="column" gap={1.5}>
                        {block.items.map((item, i) => (
                          <MKTypography
                            key={i}
                            sx={{
                              fontSize: "0.95rem",
                              fontWeight: 500,
                              color: "#700808",
                              backgroundColor: "rgba(112,8,8,0.05)",
                              px: 2,
                              py: 1,
                              borderRadius: "0.75rem",
                            }}
                          >
                            {item}
                          </MKTypography>
                        ))}
                      </MKBox>
                    </MKBox>
                  </Grid>
                ))}
              </Grid>

              {/* Social & Address */}
              <MKBox textAlign="center">
                <MKBox display="flex" justifyContent="center" gap={2} mb={2}>
                  {[
                    {
                      icon: <WhatsAppIcon />,
                      color: "#25D366",
                      link: "https://wa.me/250795305418",
                    },
                    {
                      icon: <FacebookIcon />,
                      color: "#1877F2",
                      link: "https://facebook.com/helpereverywhere",
                    },
                    {
                      icon: <InstagramIcon />,
                      color: "#E4405F",
                      link: "https://instagram.com/helpereverywhere",
                    },
                    {
                      icon: <TwitterIcon />,
                      color: "#1DA1F2",
                      link: "https://twitter.com/helpereverywhere",
                    },
                  ].map((social, idx) => (
                    <MKBox
                      key={idx}
                      component="a"
                      href={social.link}
                      target="_blank"
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: "14px",
                        backgroundColor: "rgba(0,0,0,0.04)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          backgroundColor: social.color,
                          transform: "translateY(-2px)",
                          "& svg": { color: "#fff" },
                        },
                      }}
                    >
                      {React.cloneElement(social.icon, {
                        sx: { fontSize: "1.5rem", color: social.color },
                      })}
                    </MKBox>
                  ))}
                </MKBox>

                <MKTypography variant="body2" color="text.secondary" fontWeight={500}>
                  KG 314 ST, Kigali, Rwanda
                </MKTypography>
              </MKBox>
            </MKBox>
          </Card>
        </MKBox>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </>
    </>
  );
}

export default Driver;
